/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DeliveryBoxIsoIcon24Solid = forwardRef('DeliveryBoxIsoIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.917 1.965a4 4 0 0 0-3.834 0L4.087 5.239a4 4 0 0 0-2.083 3.51v6.51a4 4 0 0 0 2.083 3.51l5.996 3.275a4 4 0 0 0 3.834 0l5.996-3.275a4 4 0 0 0 2.083-3.51v-6.51a4 4 0 0 0-2.083-3.51l-5.996-3.274Zm-7.62 5.768a.875.875 0 0 0-.844 1.534l5.672 3.119V18.5a.875.875 0 1 0 1.75 0v-6.114l5.672-3.12a.875.875 0 0 0-.844-1.533L12 10.87 6.297 7.733Z" })));
});
